import React from 'react';

class Loading extends React.Component {
    render() {
        return (
            <React.Fragment>
                <br />
                <p className="login-box-heading">We are completing your request ...</p>
                <br />
                <div className="text-center">
                    <img src="/images/spinner.gif" alt="..." />
                </div>
                <br />
                <br />
                <p className="login-box-heading">... just a moment!</p>
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/layouts/public/loading/Loading.js